import React, { useEffect, useState } from 'react';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../../../../../ui/loadingSpinner/LoadingSpinner';
import NoData from '../../../../../../ui/noData/NoData';
import { BarChart } from '@mui/x-charts';

type Props = {
  apiResponse: any;
};

const DayOfWeekCRLineChart = ({ apiResponse }: Props) => {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState<any[]>([]);

  const [loading, setLoading] = useState<
    'pending' | 'success' | 'error' | 'null'
  >('pending');

  const getConversionRateData = async (res: any) => {
    setLoading('pending');
    if (res?.type === 'DayOfWeek' && res?.data) {
      if (res.data?.length === 0) {
        setLoading('null');
        return;
      }

      setChartData(res?.data);
      setLoading('success');
    }
  };

  useEffect(() => {
    if (apiResponse) {
      getConversionRateData(apiResponse);
    }
  }, [apiResponse]);

  const valueFormatter = (value: number | null) => `${value}%`;

  return (
    <>
      {loading === 'pending' && <LoadingSpinner />}

      {loading === 'null' && (
        <NoData
          title={t('No data available')}
          subTitle={t('NeedMoreInteractionsToGenerateStats')}
        />
      )}
      {loading === 'success' && (
        <>
          <div className='chart__bottom--content-chart'>
            <div
              style={{ width: '100%' }}
              className='chart__bottom--content-chart-pie'
            >
              <BarChart
                dataset={chartData}
                xAxis={[{ scaleType: 'band', dataKey: 'day_of_week' }]}
                yAxis={[
                  {
                    // label: 'Conversion Rate (%)',
                    min: 0,
                    max: 100,
                  },
                ]}
                series={[{ dataKey: 'conversion_rate', valueFormatter }]}
                height={300}
                colors={['#8884d8']}
                margin={{ left: 50, right: 30, top: 30, bottom: 45 }}
                grid={{ vertical: true, horizontal: true }}
                sx={(theme) => ({
                  [`.${axisClasses.root}`]: {
                    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                      stroke: '#8b909a',
                      strokeWidth: 3,
                    },
                    [`.${axisClasses.tickLabel}`]: {
                      fill: '#8b909a',
                    },
                  },
                  [`.${axisClasses.left} .${axisClasses.label}`]: {
                    fill: '#8b909a',
                    // transform: 'translate(-10px, -10px)',
                  },
                  [`.${axisClasses.bottom} .${axisClasses.label}`]: {
                    fill: '#8b909a', // Change color of x-axis label
                  },
                  [`.${axisClasses.bottom} .${axisClasses.tickLabel}`]: {
                    fill: '#8b909a', // Change color of x-axis tick labels
                  },
                })}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DayOfWeekCRLineChart;
